// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1OrpL","box":"WorkspacesBox_box__2gUSG","node":"WorkspacesBox_node__1Bf16"};